/**
 * MY (马来西亚) 特性开关覆写
 * 仅覆写需要开启（true）的开关，命名规则同 diffconfig/config/featureFlags.ts：Module-Page-Feature
 */
export default {
  'Home-PendingBoard-Show': true,
  'Address-PostcodeSelector-Show': true,
  'Store-PrintLabel100x110-Enable': true,
  'Print-CcmTemplate-Enable': true
}
